<div>
    <h3><img [alt]="'Logo von ' + platform.platformName" [src]="platform.logoURL |asset">  {{ platform.heading }}</h3>
    <img [src]="'sharing/icon-check-green.png' | asset" alt="Link kopiert" class="check">
    <p class="success">Der Link zur Aufgabe wurde in die Zwischenablage kopiert.</p>
    <img [alt]="'Du kannst den Link auf ' +  platform.platformName + ' teilen'"
         [src]="pasteIcon | asset" class="share-img">
    <p>
        {{ platform.description }}
    </p>
</div>